<template>
  <div class="ai-warp">
    <div class="header-warp">
      <header class="layoutMaxWidth">
        <h2>不用带卡，刷脸吃饭 !!!</h2>
        <p>皓范食堂专业人脸支付系统</p>
        <img src="@/assets/img/face/face.png" alt />
      </header>
    </div>

    <main>
      <title>人脸支付机</title>
      <ul class="layoutMaxWidth">
        <li>
          <img src="@/assets/img/face/a1.png" alt />
          <h2>前沿科技</h2>
          <p>皓范科技首家推出商业化食堂场景实施人脸识别支付产品</p>
        </li>
        <li>
          <img src="@/assets/img/ai/a2.png" alt />
          <h2>非一般的速度</h2>
          <p>刷脸省去掏卡或者手机的麻烦，2秒支付，速度更快，有效降低食堂高峰期支付压力</p>
        </li>
        <li>
          <img src="@/assets/img/face/a3.png" alt />
          <h2>稳定性高</h2>
          <p>硬件3D结构光摄像头、自动补光、红外感应，识别精准度高达99.9%</p>
        </li>
        <li>
          <img src="@/assets/img/face/a4.png" alt />
          <h2>适应性强</h2>
          <p>采取离线识别技术，速度快，保密性高</p>
        </li>
      </ul>
    </main>
  </div>
</template>
<script>
export default {
  name: "ai",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.ai-warp {
  .header-warp {
    background: url("~@/assets/img/ai/bg1@2x.png") center center no-repeat;
    height: 437px;
  }
  header {
    display: block;
    font-style: italic;
    position: relative;
    h2 {
      padding-top: 144px;
      font-size: 56px;
      padding-bottom: 31px;
      font-weight: 700;
    }
    p {
      letter-spacing: 4px;
      font-size: 20px /*px*/;
      font-weight: 700;
    }
    img {
      position: absolute;
      top: 50px;
      right: 0;
      width: 214px;
    }
  }
  main {
    background: url("~@/assets/img/ai/bg@2x.png") top left no-repeat;
    background-size: 100% 100%;
    // width: 100%;
    height: 788px;
    title {
      display: inline-block;
      width: 100%;
      font-size: 21px;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: white;
      padding-top: 89px;
    }
    title::after,
    title::before {
      display: inline-block;
      content: "";
      width: 64px;
      height: 1px;
      background-color: #9c9fa1;
      vertical-align: middle;
      margin-right: 16px;
    }
    title::after {
      margin-right: 0px;
      margin-left: 16px;
    }
     ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 61px;
      li {
        background-color: white;
        padding: 49px 38px 0;
        margin-right: 17px;
        margin-top: 2%;
        width: 48.95%;
        height: 229px;
        box-sizing: border-box;
        img {
          width: 44px;
        }
        h2 {
          font-size: 16px;
          color: $primary-color;
          margin-top: 28px;
        }
        p {
          margin-top: 4px;
          font-size: 11px;
          line-height: 1.5em;
        }
      }
      li:nth-child(2n) {
        margin-right: 0px;
      }
      li:last-child{
        img{
          width: 46px;
        }
        h2{
          margin-top: 18px;
        }

      }
      li:nth-of-type(2){
        h2{
          margin-top: 18px;
        }
        img{
          width: 52px;
        }
      }
    }
  }
}
</style>